export const ValIsEmail = (prop, value, callback) => {
  var sValue = "";
  var serror = false;
  var smensaje = "";
  if (value === undefined || value === null || value.length == 0) {
    sValue = "";
  }

  const pattern = new RegExp("^[A-Z0-9@.-_]+$", "i");
  if (value.slice(-1) === "@" && value.length === 1) {
    sValue = "";
  } else if (
    value.slice(-1) === "@" &&
    value.substring(0, value.length - 1).includes("@")
  ) {
    sValue = value.substring(0, value.length - 1);
  } else {
    if (!pattern.test(value.slice(-1))) {
      sValue = value.substring(0, value.length - 1);
    } else {
      sValue = value;
    }
  }
  return callback(prop, sValue, serror, smensaje);
};
